import React from "react";
import ReactDOM from "react-dom";
import { Provider } from "react-redux";
import { ConnectedRouter } from "react-router-redux";
import { createBrowserHistory } from "history";
import configureStore from "./store/configureStore";
import App from "./App";
import registerServiceWorker from "./registerServiceWorker";
import { unregister } from './registerServiceWorker';
import MuiThemeProvider from "material-ui/styles/MuiThemeProvider";
import cookie from "react-cookies";
import './i18n';

import { serverSettingsService } from "services/serversettings.service";

import "assets/scss/material-kit-react.css?v=1.3.0";
import 'bootstrap/dist/css/bootstrap.min.css';
import 'react-bootstrap-table-next/dist/react-bootstrap-table2.min.css';
import { storagePrefix } from "helpers";
import { userService } from "services";
// Create browser history to use in the Redux store

export const history = createBrowserHistory({
    basename:
        (cookie.load("baseUrl" + window.location.hostname) !== "/"
            ? decodeURIComponent(cookie.load("baseUrl" + window.location.hostname)).toLowerCase()
            : "") + "/"
});

// Get the application-wide store instance, prepopulating with state from the server where available.
const initialState = window.initialReduxState;
export const store = configureStore(history, initialState);

const rootElement = document.getElementById("root");

const app = () =>
  ReactDOM.render(
    <Provider store={store}>
      <MuiThemeProvider>
        <ConnectedRouter history={history}>
          <App />
        </ConnectedRouter>
      </MuiThemeProvider>
    </Provider>,
    rootElement
  );

userService.initKeycloak(app);

serverSettingsService.getUseServiceWorkers().then(use => {
    if (use) {
        registerServiceWorker();
    } else {
        unregister();
    }
});